<script lang="ts" setup>
import iconLeft from '~/assets/img/icons/pagination/arrow-left.svg'
import iconRight from '~/assets/img/icons/pagination/arrow-right.svg'

const props = defineProps({
  currentPage: {
    // type: Number,
    default: 1
  },
  currentPageSize: {
    // type: Number,
  },
  pageCount: {
    // type: Number,
    default: 10,
  },
  isLoading: {
    // type: Number,
    default: false,
  },
  isFirstPage: {
    type: Boolean,
    default: false,
  },
  isLastPage: {
    type: Boolean,
    default: false,
  },
  prev: {
    type: Function,
  },
  next: {
    type: Function,
  },
})

const emit = defineEmits(['prev', 'next', 'pageClick'])

const pages = ref(5)

function getVisiblePages(
  currentPage: number,
  totalPages: number,
  visiblePageCount: number = 4
) {
  let start = Math.max(1, currentPage - 2);
  const end = Math.min(totalPages, currentPage + (visiblePageCount - (currentPage - start)));

  // If there are fewer pages than the desired visiblePageCount,
  // we adjust the start index accordingly.
  if (end - start < visiblePageCount - 1) {
    start = Math.max(1, end - (visiblePageCount - 1));
  }

  const visiblePages = [];
  for (let i = start; i <= end; i++) {
    visiblePages.push(i);
  }

  return visiblePages
}

const visiblePages = computed(() => {
  return getVisiblePages(props.currentPage, props.pageCount)
})

const onClick = (eventType, payload?) => {
  if (props.isLoading) return;
  switch (eventType) {
    case 'prev':
      emit('prev')
      break;
    case 'next':
      emit('next')
      break;
    case 'pageClick':
      emit('pageClick', payload)
      break;
  }
}
</script>
<template>
  <div>
    <div class="pagination">
      <button
        class="icon prev-page"
        :class="{ disabled: isFirstPage || isLoading }"
        @click="onClick('prev')"
      >
        <img
          :src="iconLeft"
          alt="iconLeft"
        >
      </button>
      <button
        v-for="(page, index) in visiblePages"
        :key="index"
        :class="{ active: currentPage === page,disabled: isLoading }"
        @click="onClick('pageClick', page)"
      >
        {{ page }}
      </button>
      <button
        class="icon next-page"
        :class="{ disabled: isLastPage || isLoading }"
        @click="onClick('next')"
      >
        <img
          :src="iconRight"
          alt="iconRight"
        >
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.pagination {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;

  color: #1F163B;

  .icon {
    padding: 9px 11px;
  }
  > button {
    border: 1px solid #E3E3E3;
    color: #1F163B;


    &:first-child {
      border: 1px solid #E3E3E3;
      border-radius: 3px 0px 0px 3px;
    }
    &:last-child {
      border: 1px solid #E3E3E3;
      border-radius: 0px 3px 3px 0px;
    }

    &:hover {
      background: rgba(45, 45, 134, 0.1);
    }

    padding: 6px 9px;
    margin: 0 -1px;

    &.active {
      &.disabled {
        background: var(--primary-color, #2D2D86);
      }
      background: var(--primary-color, #2D2D86);
      color: white;
    }

    &.disabled {
      background: rgba(45, 45, 134, 0.1);
    }
  }
}

</style>

